import { render, staticRenderFns } from "./SearchDialog.vue?vue&type=template&id=53115c97&scoped=true&"
import script from "./SearchDialog.vue?vue&type=script&lang=js&"
export * from "./SearchDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53115c97",
  null
  
)

export default component.exports